import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getMyProducts } from "@tLinc/Services/CustomMyProductService";

export const LoadMyProducts = (props: { dispatch: (arg0: { type: string; result: any }) => void; parameter: any }) => {
    const myProductsData = "";
    props.dispatch({
        type: "Custom/MyProducts/CompleteLoadMyProducts",
        result: myProductsData,
    });
};

export const chain = [LoadMyProducts];

const loadMyProducts = createHandlerChainRunner(chain, "LoadMyProducts");

export default loadMyProducts;
